export default {
    loading: 'statisticView:loading',
    search: 'statisticView:search',
    taskInfos: 'statisticView:taskInfos',//营运量 targepv 统计
    url: 'statisticView:url',
}

//获取RangePicker控件时间戳：2017-09-18~2017-09-18 适用于：开始时间：09-18：0:0:0 结束时间：09-18：23:59:59
export const trunRangePicker = function (values) {
    if (!values || values.length == 0) {
        return;
    }
    let s_time = new Date(values[0]);
    s_time.setHours(0);
    s_time.setMinutes(0);
    s_time.setSeconds(0);
    s_time.setMilliseconds(0);
    let e_time = new Date(values[1]);
    e_time.setHours(23);
    e_time.setMinutes(59);
    e_time.setSeconds(59);
    e_time.setMilliseconds(0);
    return { start_time: s_time.getTime(), end_time: e_time.getTime() };
}


// WEBPACK FOOTER //
// ./pages/StatisticalAnalysis/statistics-view/constant.js